import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../utils/axios";
import {
  Box,
  Button,
  Heading,
  Spinner,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Flex,
} from "@chakra-ui/react";
import { UserContext } from "../../context/UserContext";
import DownloadUsersCSVButton from "../../components/DownloadUsersCSVButton";
import PrintableUserLabelsDocumentButton from "../../components/PrintableUserLabelsDocumentButton";
import PrintableFamilyLabelsButton from "../../components/PrintableFamilyLabelsButton";
import AdminUserFilter from "../../components/AdminUserFilter";
import AdminUserTableFooter from "../../components/AdminUserTableFooter";
import { hasPermission, renderArrow } from "../../utils/helpers";
import { prettyPrintLastName } from "../../utils/PrettyPrints";

function AdminRegistrationHome() {
  const { user, language } = useContext(UserContext);
  const navigate = useNavigate();

  const [filteredUsers, setFilteredUsers] = useState(null);
  const [pageLoading, setPageLoading] = useState(true);

  const [pageNumber, setPageNumber] = useState(1);
  const [pageTotal, setPageTotal] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [pageNumberChange, setPageNumberChange] = useState(false);

  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("");

  //jyh
  const [lodgings, setLodgings] = useState([]);
  const [meals, setMeals] = useState([]);

  function prettyPrintChurch(u) {
    if (!u.church) {
      return "Other: " + (u.churchOther || "");
    }

    return u.church?.name || u.church?.long_name
      ? `${u.church?.name}: ${u.church?.long_name}`
      : "";
  }

  function handleNavigateYourFamily() {
    navigate(`/admin/registration/family/${user.familyId}`);
  }

  function handleViewFamily(familyId) {
    navigate(`/admin/registration/family/${familyId}`);
  }

  function handleUpdate(id) {
    navigate(`/admin/registration/${id}`);
  }

  async function handleDelete(u) {
    if (
      // eslint-disable-next-line no-alert
      window.confirm(
        `Are you sure you wish to delete user ${u.firstName} ${u.lastName}?`
      )
    ) {
      try {
        await api.delete(`/api/users/${u._id}`);
        setFilteredUsers(filteredUsers.filter((user) => user._id !== u._id));
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }

      // eslint-disable-next-line no-alert
      alert("User deleted");
    }
  }

  const handleSort = (field) => {
    const newSortOrder =
      sortBy === field && sortOrder === "asc" ? "desc" : "asc";
    setSortBy(field);
    setSortOrder(newSortOrder);
  };

  // jyh
  useEffect(() => {
    api.get("/api/lodgings").then((res) => {
      setLodgings(res.data);
    });
    api.get("/api/meals").then((res) => {
      setMeals(res.data);
    });
  }, []);

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Heading textAlign="center" margin="20px">
        {language === "en" ? "Registration" : "登记注册"}
      </Heading>
      <Button onClick={() => handleNavigateYourFamily()}>
        {language == "en" ? "View Your Family" : "查看您的家人"}
      </Button>
      <AdminUserFilter
        setFilteredUsers={setFilteredUsers}
        setPageLoading={setPageLoading}
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
        pageSize={pageSize}
        setPageTotal={setPageTotal}
        pageNumberChange={pageNumberChange}
        sortBy={sortBy}
        sortOrder={sortOrder}
      />
      {pageLoading ? (
        <Spinner size="xl" />
      ) : (
        <>
          <TableContainer margin={5}>
            <Table size="sm">
              <Thead>
                <Tr style={{ cursor: "pointer" }}>
                  <Th scope="col" onClick={() => handleSort("firstName")}>
                    First Name {renderArrow("firstName", sortBy, sortOrder)}
                  </Th>
                  <Th scope="col" onClick={() => handleSort("lastName")}>
                    Last Name {renderArrow("lastName", sortBy, sortOrder)}
                  </Th>
                  <Th scope="col" onClick={() => handleSort("chineseName")}>
                    Chin. Name {renderArrow("chineseName", sortBy, sortOrder)}
                  </Th>
                  <Th scope="col" onClick={() => handleSort("email")}>
                    Email {renderArrow("email", sortBy, sortOrder)}
                  </Th>
                  <Th scope="col">Attending</Th>
                  <Th scope="col" onClick={() => handleSort("familyId")}>
                    Fam. Id {renderArrow("familyId", sortBy, sortOrder)}
                  </Th>
                  <Th scope="col" onClick={() => handleSort("group")}>
                    Group {renderArrow("group", sortBy, sortOrder)}
                  </Th>
                  <Th scope="col" onClick={() => handleSort("church")}>
                    Church {renderArrow("church", sortBy, sortOrder)}
                  </Th>
                  <Th scope="col" onClick={() => handleSort("age")}>
                    Age {renderArrow("age", sortBy, sortOrder)}
                  </Th>
                  <Th scope="col" onClick={() => handleSort("grade")}>
                    Grade {renderArrow("grade", sortBy, sortOrder)}
                  </Th>
                  <Th scope="col"></Th>
                  <Th scope="col"></Th>
                  <Th scope="col"></Th>
                </Tr>
              </Thead>
              <Tbody>
                {filteredUsers &&
                  filteredUsers.map((u) => (
                    <Tr key={u._id}>
                      <Td>{u.firstName}</Td>
                      <Td>{prettyPrintLastName(u)}</Td>
                      <Td>{u.chineseName}</Td>
                      <Td>{u.email}</Td>
                      <Td>
                        {u.registrationStatus === "Not Attending"
                          ? "No"
                          : "Yes"}
                      </Td>
                      <Td>{u.familyId}</Td>
                      <Td>{u.groupName}</Td>
                      <Td>{prettyPrintChurch(u)}</Td>
                      <Td>{u.age >= 0 ? u.age : ""}</Td>
                      <Td>{u.grade}</Td>
                      <Td>
                        <Button onClick={() => handleViewFamily(u.familyId)}>
                          View Family
                        </Button>
                      </Td>
                      <Td>
                        <Button
                          colorScheme="yellow"
                          isDisabled={
                            !hasPermission(user, ["edit_users", "assign_groups"]) &&
                            (u.familyId != user.familyId || !user.registerer)
                          }
                          onClick={() => handleUpdate(u._id)}
                        >
                          Update
                        </Button>
                      </Td>
                      <Td>
                        <Button
                          isDisabled={
                            u._id === user?._id ||
                            !hasPermission(user, "delete_users")
                          }
                          colorScheme="red"
                          onClick={() => handleDelete(u)}
                        >
                          Delete
                        </Button>
                      </Td>
                    </Tr>
                  ))}
              </Tbody>
            </Table>
          </TableContainer>
          <AdminUserTableFooter
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            pageSize={pageSize}
            setPageSize={setPageSize}
            pageTotal={pageTotal}
            pageNumberChange={pageNumberChange}
            setPageNumberChange={setPageNumberChange}
          />
          <Flex>
            <DownloadUsersCSVButton user={user} attendingUsers={true} language={language} filteredUsers={filteredUsers} lodgings={lodgings} meals={meals}/>{" "}
            <DownloadUsersCSVButton user={user} attendingUsers={true} language={language} lodgings={lodgings} meals={meals}/>{" "}
            <DownloadUsersCSVButton user={user} attendingUsers={false} language={language} lodgings={lodgings} meals={meals}/>
          </Flex>
          <Flex>
            <PrintableUserLabelsDocumentButton />
            <PrintableFamilyLabelsButton />
          </Flex>
        </>
      )}
    </Box>
  );
}

export default AdminRegistrationHome;
